import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4.222 2A2.215 2.215 0 0 0 2 4.222v15.556A2.22 2.22 0 0 0 4.222 22h15.556A2.22 2.22 0 0 0 22 19.778V12h-2.222v7.778H4.222V4.222H12V2zm14.2 1.111a.77.77 0 0 0-.533.222l-1.356 1.345 2.778 2.778 1.356-1.345a.75.75 0 0 0 0-1.055l-1.723-1.723a.74.74 0 0 0-.522-.222m-2.678 2.356-8.188 8.2v2.777h2.777l8.19-8.2z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }